export const organizerSharedConfig = {
  queryParams: {
    fromActivityPlanning: 'from-activity-planning',
    from: 'from',
    activityEdition: 'activity-edition',
    onboardingEdition: 'onboarding-edition',
  },
  messaging: {
    notification: {
      sessionStorageKey: 'organizer-messaging-notifications',
    },
  },
};
